<div class="acs-call" [class.acs-call-fullscreen]="isFullscreen">

  <!-- Connecting -->
  <div class="acs-call-status" *ngIf="callState === 'connecting'">
    <div class="acs-call-spinner"></div>
    <span>{{ labels.connecting }}</span>
  </div>

  <!-- Ringing -->
  <div class="acs-call-status" *ngIf="callState === 'ringing'">
    <div class="acs-call-spinner"></div>
    <span>{{ labels.ringing }}</span>
  </div>

  <!-- Connected -->
  <div class="acs-call-connected" *ngIf="callState === 'connected'">

    <!-- Top bar: timer + participant count -->
    <div class="acs-call-topbar">
      <div class="acs-call-timer">
        <span class="acs-call-timer-dot"></span>
        <span>{{ callDuration }}</span>
        <span class="acs-call-recording-indicator" *ngIf="isRecordingActive">
          <span class="acs-call-recording-dot"></span>
          REC
        </span>
      </div>
      <div class="acs-call-participant-count">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
        </svg>
        <span>{{ remoteParticipants.length + 1 }}</span>
      </div>
    </div>

    <!-- Recording warning banner -->
    <div class="acs-call-recording-warning" *ngIf="recordingWarning && showRecordingWarning">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
      <span>Recording may not be active. This call might not be recorded. Consider ending the call and trying again.</span>
    </div>

    <!-- Camera permission denied notice -->
    <div class="acs-call-permission-notice" *ngIf="cameraPermissionDenied">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>
      </svg>
      <span>{{ labels.cameraDenied }}</span>
    </div>

    <div class="acs-call-video-area">
      <!-- Remote video grid -->
      <div class="acs-call-remote-grid" #remoteVideoGrid
           [class.acs-call-remote-grid-1]="remoteParticipants.length <= 1"
           [class.acs-call-remote-grid-2]="remoteParticipants.length === 2"
           [class.acs-call-remote-grid-many]="remoteParticipants.length > 2">

        <!-- Remote participants -->
        <div class="acs-call-remote-tile" *ngFor="let rpView of remoteParticipants">
          <div class="acs-call-remote-video"
               [attr.data-participant-id]="$any(rpView.participant.identifier)?.communicationUserId || $any(rpView.participant.identifier)?.rawId || rpView.displayName">
          </div>
          <div class="acs-call-remote-avatar" *ngIf="!rpView.hasVideo">
            <div class="acs-call-avatar-circle">
              {{ rpView.displayName?.charAt(0)?.toUpperCase() || '?' }}
            </div>
            <span class="acs-call-remote-name">{{ rpView.displayName }}</span>
          </div>
          <div class="acs-call-remote-label" *ngIf="rpView.hasVideo">
            <span>{{ rpView.displayName }}</span>
            <svg *ngIf="rpView.isMuted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14" class="acs-call-muted-icon">
              <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V20c0 .55.45 1 1 1s1-.45 1-1v-2.28c.91-.13 1.77-.45 2.55-.9l4.18 4.18L21 19.73 4.27 3z"/>
            </svg>
          </div>
          <!-- Muted indicator on avatar view -->
          <div class="acs-call-remote-muted-badge" *ngIf="!rpView.hasVideo && rpView.isMuted">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
              <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V20c0 .55.45 1 1 1s1-.45 1-1v-2.28c.91-.13 1.77-.45 2.55-.9l4.18 4.18L21 19.73 4.27 3z"/>
            </svg>
          </div>
        </div>

        <!-- No participants yet -->
        <div class="acs-call-waiting" *ngIf="remoteParticipants.length === 0">
          <div class="acs-call-active-indicator">
            <span class="acs-call-pulse"></span>
            <span>{{ labels.waitingForOthers }}</span>
          </div>
        </div>
      </div>

      <!-- Local video (PiP) -->
      <div class="acs-call-local-pip" *ngIf="isCameraOn">
        <div class="acs-call-local-video" #localVideoContainer></div>
      </div>
    </div>

    <div class="acs-call-controls">
      <!-- Mute/Unmute -->
      <button class="acs-call-btn" [class.acs-call-btn-active]="isMuted" (click)="toggleMute()" [title]="isMuted ? 'Unmute' : 'Mute'">
        <svg *ngIf="!isMuted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z"/>
        </svg>
        <svg *ngIf="isMuted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V20c0 .55.45 1 1 1s1-.45 1-1v-2.28c.91-.13 1.77-.45 2.55-.9l4.18 4.18L21 19.73 4.27 3z"/>
        </svg>
      </button>

      <!-- Camera toggle -->
      <button class="acs-call-btn" [class.acs-call-btn-active]="isCameraOn" (click)="toggleCamera()" [title]="cameraPermissionDenied ? 'Camera access denied' : isCameraOn ? 'Turn off camera' : 'Turn on camera'" [disabled]="cameras.length === 0 || cameraPermissionDenied">
        <svg *ngIf="isCameraOn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
        </svg>
        <svg *ngIf="!isCameraOn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>
        </svg>
      </button>

      <!-- Device settings with popup -->
      <div class="acs-call-device-wrapper">
        <div class="acs-call-device-popup" *ngIf="showDeviceMenu">
          <div class="acs-call-device-group" *ngIf="microphones.length > 0">
            <label>{{ labels.microphoneLabel }}</label>
            <select [value]="selectedMicrophoneId" (change)="selectMicrophone($any($event.target).value)">
              <option *ngFor="let mic of microphones" [value]="mic.id">{{ mic.name }}</option>
            </select>
          </div>
          <div class="acs-call-device-group" *ngIf="speakers.length > 0">
            <label>{{ labels.speakerLabel }}</label>
            <select [value]="selectedSpeakerId" (change)="selectSpeaker($any($event.target).value)">
              <option *ngFor="let speaker of speakers" [value]="speaker.id">{{ speaker.name }}</option>
            </select>
          </div>
          <div class="acs-call-device-group" *ngIf="cameras.length > 0">
            <label>{{ labels.cameraLabel }}</label>
            <select [value]="selectedCameraId" (change)="selectCamera($any($event.target).value)">
              <option *ngFor="let cam of cameras" [value]="cam.id">{{ cam.name }}</option>
            </select>
          </div>
        </div>
        <button class="acs-call-btn" [class.acs-call-btn-active]="showDeviceMenu" (click)="toggleDeviceMenu()" title="Device Settings">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
            <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.49.49 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.49.49 0 0 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
          </svg>
        </button>
      </div>

      <!-- Fullscreen toggle -->
      <button class="acs-call-btn" [class.acs-call-btn-active]="isFullscreen" (click)="toggleFullscreen()" [title]="isFullscreen ? 'Exit fullscreen' : 'Fullscreen'">
        <svg *ngIf="!isFullscreen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
        </svg>
        <svg *ngIf="isFullscreen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
        </svg>
      </button>

      <!-- Hang up -->
      <button class="acs-call-btn acs-call-btn-hangup" (click)="hangUp()" title="Hang Up">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.956.956 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.1-.7-.28-.79-.73-1.68-1.36-2.66-1.85a.994.994 0 0 1-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Disconnected -->
  <div class="acs-call-status" *ngIf="callState === 'disconnected'">
    <span>{{ labels.callEnded }}</span>
  </div>

  <!-- Error -->
  <div class="acs-call-error" *ngIf="callState === 'error'">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
    </svg>
    <span>{{ errorMessage }}</span>
  </div>

</div>
